import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './Contacto.css';

const Contacto = () => {
  // Array de imágenes para el carrusel de contacto
  const contactImages = [
    { 
      src: '/images/fotos/jamalcoStean/jamalcoStean_35.jpg', 
      alt: 'Servicios profesionales',
      title: 'Excelencia en cada proyecto',
      subtitle: 'Tu visión es nuestra prioridad'
    },
    { 
      src: '/images/fotos/otros/Rever_3.webp', 
      alt: 'Proyecto industrial',
      title: 'Soluciones innovadoras',
      subtitle: 'Calidad garantizada'
    },
    { 
      src: '/images/fotos/otros/Rever_17.webp', 
      alt: 'Construcción especializada',
      title: 'Experiencia comprobada',
      subtitle: 'Resultados excepcionales'
    },
    { 
      src: '/images/fotos/otros/Rever_20.webp', 
      alt: 'Infraestructura moderna',
      title: 'Proyectos de clase mundial',
      subtitle: 'Compromiso con la excelencia'
    },
    { 
      src: '/images/fotos/otros/Rever_22.webp', 
      alt: 'Tecnología avanzada',
      title: 'Innovación constante',
      subtitle: 'Superando expectativas'
    }
  ];

  // Opciones del carrusel para contacto
  const contactCarouselOptions = {
    type: 'loop',
    perPage: 1,
    autoplay: true,
    interval: 6000,
    pauseOnHover: true,
    resetProgress: false,
    height: '500px',
    speed: 1500,
    arrows: true,
    pagination: true,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    classes: {
      arrows: 'splide__arrows contact-arrows',
      arrow: 'splide__arrow contact-arrow',
      prev: 'splide__arrow--prev contact-arrow-prev',
      next: 'splide__arrow--next contact-arrow-next',
      pagination: 'splide__pagination contact-pagination',
      page: 'splide__pagination__page contact-page'
    }
  };

  return (
    <div className="contact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Contacto <span className="highlight">Rêver</span></h2>
          <div className="animated-underline"></div>
          <p className="section-subtitle">Cuéntanos tu nuevo proyecto.</p>
        </div>
        
        <div className="contact-wrapper">
          {/* Tarjeta principal de contacto */}
          <div className="contact-card">
            <div className="card-content">
              <div className="card-header">
                <div className="premium-badge">
                  <svg className="premium-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 1l3.22 6.515 7.197.617-5.385 4.918 1.5 7.084L12 16.89l-6.532 3.244 1.5-7.084-5.384-4.918 7.196-.617z"/>
                  </svg>
                  <span>Atención personalizada</span>
                </div>
              </div>
              
              <div className="contact-methods">
                {/* Método de contacto: Teléfono */}
                <div className="contact-method">
                  <div className="method-icon-wrapper">
                    <svg className="method-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z"/>
                    </svg>
                  </div>
                  <div className="method-info">
                    <h4>Teléfono</h4>
                    <a href="https://wa.me/525534744687" target="_blank" rel="noopener noreferrer" className="contact-link">
                      +52 55 3474 4687
                      <span className="link-badge">WhatsApp disponible</span>
                    </a>
                  </div>
                </div>
                
                {/* Método de contacto: Email */}
                <div className="contact-method">
                  <div className="method-icon-wrapper">
                    <svg className="method-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z"/>
                    </svg>
                  </div>
                  <div className="method-info">
                    <h4>E-mail</h4>
                    <div className="email-links">
                      <a href="mailto:lsanchez@reverlat.com" target="_blank" rel="noopener noreferrer" className="contact-link">lsanchez@reverlat.com</a>
                      <a href="mailto:info@reverlat.com" target="_blank" rel="noopener noreferrer" className="contact-link">info@reverlat.com</a>
                    </div>
                  </div>
                </div>
                
              </div>
              
              <div className="contact-cta">
                <div className="cta-highlight">
                  <div className="pulse-dot"></div>
                  <p>Tiempo de respuesta promedio: <span className="highlight">24 horas</span></p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Carrusel de contacto con efectos */}
          <div className="contact-visual">
            <div className="visual-container">
              <div className="contact-carousel-frame">
                <Splide options={contactCarouselOptions} className="contact-carousel">
                  {contactImages.map((image, index) => (
                    <SplideSlide key={index}>
                      <div className="contact-slide">
                        <img src={image.src} alt={image.alt} className="contact-image" />
                        <div className="image-overlay">
                          <div className="overlay-content">
                            <h3>{image.title}</h3>
                            <p>{image.subtitle}</p>
                          </div>
                        </div>
                      </div>
                    </SplideSlide>
                  ))}
                </Splide>
              </div>
              
              <div className="trust-indicators">
                <div className="trust-badge">
                  <svg className="trust-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.959 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z"/>
                  </svg>
                  <span>Proyectos certificados</span>
                </div>
                <div className="trust-badge">
                  <svg className="trust-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z"/>
                  </svg>
                  <span>Garantía de satisfacción</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Patrones decorativos */}
      <div className="decoration-pattern pattern-left"></div>
      <div className="decoration-pattern pattern-right"></div>
    </div>
  );
};

export default Contacto;